import DashboardPage from "@/pages/dashboard/dashboard-page.vue";
import { RouteRecordRaw } from "vue-router";
const SchedulerStandsPage = () => import("../pages/stands/stands-page.vue");
const SchedulerTagsPage = () => import("../pages/tags/tags-page.vue");
const SchedulerSecretsPage = () => import("../pages/secrets/secrets-page.vue");
const SchedulerKuberPage = () => import("../pages/kubers/kubers-page.vue");
const SchedulerPage = () => import("../pages/scheduler/scheduler-page.vue");
const JobPage = () => import("../pages/job/job-page.vue");

/**Маршруты проекта */
const SchedulerRoutes: RouteRecordRaw[] = [
  {
    name: "scheduler-project",
    path: "project/:id",
    component: DashboardPage,
    props: true,
    meta: {
      title: "Dashboard | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "dashboard",
    path: "dashboard/project/:id",
    component: DashboardPage,
    props: true,
    meta: {
      title: "Dashboard | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "scheduler-root",
    path: "project/:id/root",
    component: SchedulerPage,
    props: true,
    meta: {
      title: "Root | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "scheduler-folder",
    path: "project/:id/folder/:folderId",
    component: SchedulerPage,
    props: true,
    meta: {
      title: "Folder | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "scheduler-job",
    path: "project/:id/folder/:folderId/job/:jobId",
    component: JobPage,
    props: true,
    meta: {
      title: "Job | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "scheduler-stands",
    path: "project/:id/stands",
    component: SchedulerStandsPage,
    props: true,
    meta: {
      title: "Stands | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "scheduler-kubers",
    path: "project/:id/kubers",
    component: SchedulerKuberPage,
    props: true,
    meta: {
      title: "AargoCD | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "scheduler-secrets",
    path: "project/:id/secrets",
    component: SchedulerSecretsPage,
    props: true,
    meta: {
      title: "Secrets | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
  {
    name: "scheduler-tags",
    path: "project/:id/tags",
    component: SchedulerTagsPage,
    props: true,
    meta: {
      title: "Tags | Scheduler",
      isAuth: true,
      roles: [],
    },
  },
];

export default SchedulerRoutes;
